import { render, staticRenderFns } from "./promocaoaceite.vue?vue&type=template&id=48f2b083"
import script from "./promocaoaceite.vue?vue&type=script&lang=js"
export * from "./promocaoaceite.vue?vue&type=script&lang=js"
import style0 from "./promocaoaceite.vue?vue&type=style&index=0&id=48f2b083&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports